import { toast } from 'sonner';
import { promiseWithMinDelay } from './promiseWithMinDelay';

const defaultOptions = {
	duration: 3000,
};

export const showToast = {
	success: (message, options = {}) => {
		return toast.success(message, { ...defaultOptions, ...options });
	},

	error: (message, options = {}) => {
		return toast.error(message, { ...defaultOptions, ...options });
	},

	warning: (message, options = {}) => {
		return toast.warning(message, { ...defaultOptions, ...options });
	},

	info: (message, options = {}) => {
		return toast.info(message, { ...defaultOptions, ...options });
	},

	promise: (promise, messages, options = {}) => {
		const minDelay = options.minDelay !== undefined ? options.minDelay : 500;
		const promiseWithDelay = minDelay > 0 ? promiseWithMinDelay(promise, minDelay) : promise;

		return toast.promise(promiseWithDelay, {
			loading: messages.loading || 'Loading...',
			success: messages.success || 'Success!',
			error: messages.error || 'Error occurred',
		});
	},

	dismiss: (toastId) => {
		return toast.dismiss(toastId);
	},
};

export { toast };
